module.exports = __webpack_public_path__ + "py.1a604331.svg";